const routes = [{
  path: '/users',
  component: () => import('@/views/users'),
  name: 'users-msg',
  meta: {
    title: '个人信息'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/users.js